(ns ballot-scout-v2-frontend.widget.i18n
  (:require
   [ballot-scout-v2-frontend.widget.subs :as s.widget]
   [ballot-scout-v2-frontend.widget.translations :refer [translations-dict]]
   [clojure.string :as str]
   [re-frame.core :as rf]
   [taoensso.tempura :as tempura])
  (:import
   [goog.i18n
    DateTimePatterns DateTimeSymbols
    DateTimePatterns_ar DateTimeSymbols_ar
    DateTimePatterns_de DateTimeSymbols_de
    DateTimePatterns_en DateTimeSymbols_en
    DateTimePatterns_es DateTimeSymbols_es
    DateTimePatterns_ko DateTimeSymbols_ko
    DateTimePatterns_pl DateTimeSymbols_pl
    DateTimePatterns_ru DateTimeSymbols_ru
    DateTimePatterns_sw DateTimeSymbols_sw
    DateTimePatterns_tl DateTimeSymbols_tl
    DateTimePatterns_vi DateTimeSymbols_vi
    DateTimePatterns_zh DateTimeSymbols_zh]))

(def rtl-langs #{:ar})

(defn rtl-lang? [lang]
  (contains? rtl-langs lang))

;; Identifying wide endonym languages is helpful in setting the language selector component width
(def wide-endonym-langs #{:vi})

(defn wide-endonym-lang? [lang]
  (contains? wide-endonym-langs lang))

(defn set-datetime-patterns
  "Directly sets the goog.i18n DateTimePatterns and DateTimeSymbols globals 
   -- typically in response to a user event."
  [locale]
  (case locale
    :ar
    (do (set! DateTimePatterns DateTimePatterns_ar)
        (set! DateTimeSymbols DateTimeSymbols_ar))
    :de
    (do (set! DateTimePatterns DateTimePatterns_de)
        (set! DateTimeSymbols DateTimeSymbols_de))
    :es
    (do (set! DateTimePatterns DateTimePatterns_es)
        (set! DateTimeSymbols DateTimeSymbols_es))
    :ko
    (do (set! DateTimePatterns DateTimePatterns_ko)
        (set! DateTimeSymbols DateTimeSymbols_ko))
    :pl
    (do (set! DateTimePatterns DateTimePatterns_pl)
        (set! DateTimeSymbols DateTimeSymbols_pl))
    :ru
    (do (set! DateTimePatterns DateTimePatterns_ru)
        (set! DateTimeSymbols DateTimeSymbols_ru))
    :sw
    (do (set! DateTimePatterns DateTimePatterns_sw)
        (set! DateTimeSymbols DateTimeSymbols_sw))
    :tl
    (do (set! DateTimePatterns DateTimePatterns_tl)
        (set! DateTimeSymbols DateTimeSymbols_tl))
    :vi
    (do (set! DateTimePatterns DateTimePatterns_vi)
        (set! DateTimeSymbols DateTimeSymbols_vi))
    :zh
    (do (set! DateTimePatterns DateTimePatterns_zh)
        (set! DateTimeSymbols DateTimeSymbols_zh))
    ;else
    (do (set! DateTimePatterns DateTimePatterns_en)
        (set! DateTimeSymbols DateTimeSymbols_en))))

(defn supported-language? [lang]
  (some #(= lang %) (keys translations-dict)))

(defn default-language
  []
  (if-let [browser-lang (some-> (.. js/window -navigator -language)
                                (str/split #"-")
                                first
                                str/lower-case
                                keyword)]
    (if (supported-language? browser-lang)
      browser-lang
      :en)
    :en))

(defn tr [str-ref & interpolations]
  (let [selected-lang @(rf/subscribe [::s.widget/widget-language])
        all-langs [(or selected-lang :en)]]
    (tempura/tr {:dict translations-dict} all-langs
                str-ref (vec interpolations))))

(rf/reg-sub
 ::right-to-left?
 :<- [::s.widget/widget-language]
 (fn [lang] (rtl-lang? lang)))
